import {useQuery} from "@tanstack/react-query";
import {GetUserResponse, Token, UsersApi} from "@devour/client";
import getConfig from "@/utils/getConfig";
import * as Sentry from "@sentry/react";

export const USE_GET_USER_PROFILE_KEY = "user-profile";

async function fetchUserProfile(fullToken: Token): Promise<GetUserResponse> {
    const userRes = await new UsersApi(getConfig(fullToken)).getUsersProfile();
    Sentry.setUser({
        email: userRes.user.email,
    });
    Sentry.setContext("userInfo", {...userRes.user});
    return userRes;
}

function userProfileQuery(fullToken: Token, disabled?: boolean) {
    return {
        queryKey: [
            USE_GET_USER_PROFILE_KEY,
            fullToken?.id,
        ],
        queryFn: () => fetchUserProfile(fullToken),
        staleTime: 30 * 60000,
        keepPreviousData: true,
        enabled: Boolean(fullToken && !disabled),
        refetchOnWindowFocus: false, // Don't refetch on tab switch - we have 30 min cache
    } as const;
}

export function useGetUserProfile(fullToken: Token, disabled?: boolean) {
    return useQuery(userProfileQuery(fullToken, disabled));
}